(() => {
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  const syncExpandedState = (details) => {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  };

  const createSummary = (header, contentId) => {
    const summary = document.createElement('summary');
    summary.className = 'senlan-mobile-accordion__summary';
    summary.setAttribute('aria-controls', contentId);
    summary.setAttribute('aria-expanded', 'false');
    summary.append(header);
    return summary;
  };

  const createItem = (module, headerSelector, contentId, moduleName) => {
    const header = module.querySelector(headerSelector);
    const details = document.createElement('details');
    details.className = 'senlan-mobile-accordion__item';
    details.dataset.senlanAccordionModule = moduleName;
    module.classList.add('senlan-mobile-accordion__content');
    module.id = contentId;
    details.append(createSummary(header, contentId), module);
    details.addEventListener('toggle', () => syncExpandedState(details));
    return details;
  };

  const prepareAboutItem = (overview) => {
    overview.classList.add('senlan-mobile-accordion__item');
    overview.dataset.senlanAccordionModule = 'about';
    overview.removeAttribute('open');

    const summary = overview.querySelector(':scope > summary');
    const panel = overview.querySelector(':scope > .senlan-content-demo__panel');
    const eyebrowIcon = summary.querySelector('.senlan-about__eyebrow-icon');
    const desktopTitle = summary.querySelector('.senlan-content-demo__heading');
    const mobileTitle = document.createElement('div');
    mobileTitle.className = `${desktopTitle.className} senlan-about__mobile-title`;
    while (desktopTitle.firstChild) mobileTitle.append(desktopTitle.firstChild);
    panel.prepend(mobileTitle);

    const mobileHeading = document.createElement('h2');
    mobileHeading.textContent = document.documentElement.lang.toLowerCase().split('-')[0] === 'fr' ? "À propos de cette variété" : document.documentElement.lang.toLowerCase().split('-')[0] === 'es' ? "Sobre esta variedad" : (document.documentElement.lang.toLowerCase().split('-')[0] === 'de' ? 'Über diese Sorte' : 'About This Variety');
    summary.className = 'senlan-mobile-accordion__summary';
    summary.replaceChildren(eyebrowIcon, mobileHeading);
    summary.setAttribute('aria-expanded', 'false');
    overview.addEventListener('toggle', () => syncExpandedState(overview));
    return overview;
  };

  const initMobileAccordion = (root) => {
    if (!mobileQuery.matches || root.dataset.senlanMobileAccordionReady === 'true') return;

    const overview = root.querySelector('.senlan-content-demo__module--overview');
    const glance = root.querySelector('.senlan-content-demo__module--glance');
    const bestConditions = root.querySelector('.senlan-content-demo__module--best-conditions');
    const gardenersLove = root.querySelector('.senlan-content-demo__module--gardeners-love');
    const howToGrow = root.querySelector('.senlan-content-demo__module--how-to-grow');
    const gardenUses = root.querySelector('.senlan-garden-uses');
    const editorialGrid = root.querySelector('.senlan-content-demo__editorial-grid');
    const guidePair = root.querySelector('.senlan-guide-pair');

    if (!overview || !glance || !gardenersLove || !howToGrow || !gardenUses || !editorialGrid || !guidePair) return;

    const group = document.createElement('div');
    group.className = 'senlan-mobile-accordion-group';
    editorialGrid.before(group);

    const accordionItems = [
      prepareAboutItem(overview),
      createItem(glance, '.senlan-glance__header', `SenlanMobileGlance-${root.dataset.sectionId || 'demo'}`, 'growing')
    ];

    if (bestConditions) {
      accordionItems.push(
        createItem(bestConditions, '.senlan-best-conditions__header', `SenlanMobileBestConditions-${root.dataset.sectionId || 'demo'}`, 'best-growing-conditions')
      );
    }

    accordionItems.push(
      createItem(gardenersLove, '.senlan-gardeners-love__header', `SenlanMobileGardeners-${root.dataset.sectionId || 'demo'}`, 'why'),
      createItem(howToGrow, '.senlan-how-to-grow__header', `SenlanMobileHow-${root.dataset.sectionId || 'demo'}`, 'how'),
      createItem(gardenUses, '.senlan-garden-uses__header', `SenlanMobileUses-${root.dataset.sectionId || 'demo'}`, 'garden-uses')
    );
    group.append(...accordionItems);

    editorialGrid.remove();
    guidePair.remove();
    root.dataset.senlanMobileAccordionReady = 'true';
  };

  const initAll = () => {
    document.querySelectorAll('[data-senlan-content-demo]').forEach(initMobileAccordion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-senlan-content-demo]');
    if (root) initMobileAccordion(root);
  });
})();
